import { Component, OnInit } from '@angular/core';
import 'hammerjs';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  
  constructor(
    private translate: TranslateService
  ){
    
    // translate.setDefaultLang('es');
    // sessionStorage.setItem('lang','es');

  }

  ngOnInit(){
    if(sessionStorage.getItem('lang')){
      this.translate.setDefaultLang(sessionStorage.getItem('lang'));
    }else{
      this.translate.setDefaultLang('es');
      sessionStorage.setItem('lang','es');
    }
  }
}
